import { sessionOrLocalStorage } from './utils';
import { SecureStoragePlugin } from '@absis/core-plugins';
/**
 * SecureStorage plugin
 *
 */
export const CBSecureStorage: SecureStoragePlugin = {
  set: (key: string, data: string): Promise<void | null> => {
    if (key) {
      if (data) {
        sessionOrLocalStorage.setItem(key, data);
        return Promise.resolve();
      }
      return Promise.resolve(null);
    }
    return Promise.resolve(null);
  },
  get: (key: string): Promise<string | null> => {
    if (key) {
      const data = sessionOrLocalStorage.getItem(key);
      if (data) {
        return Promise.resolve(data);
      }
      return Promise.resolve(null);
    }
    return Promise.resolve(null);
  },
  has: (key: string): Promise<boolean> => {
    if (key) {
      const result = sessionOrLocalStorage.getItem(key) != undefined;
      return Promise.resolve(result);
    }
    return Promise.resolve(false);
  },
  clear: (): Promise<void> => {
    sessionOrLocalStorage.clear();
    return Promise.resolve();
  },
  delete: (key: string): Promise<void | null> => {
    if (key) {
      sessionOrLocalStorage.removeItem(key);
      return Promise.resolve();
    }
    return Promise.resolve(null);
  },
};

export const CBStorage = CBSecureStorage;
